
// Price bar & price line (shader)

export default class Price {

    constructor(comp) {
        this.comp = comp
    }

    // Defines an inline shader (has access to both
    // target & overlay's contexts)
    init_shader(plot) {

        let layout = this.comp.$props.layout
        let config = this.comp.$props.config
        let comp = this.comp
        let last_bar = () => this.last_bar(plot)


        this.comp.$emit('new-shader', {
            target: 'sidebar', draw: ctx => {

                let bar = last_bar()
                if (!bar) return

                let w = ctx.canvas.width
                let h = config.PANHEIGHT
                let lbl = bar.entryPoint ? bar.entryPoint.toFixed(layout.prec) : 0
                ctx.fillStyle = bar.entryColor

                let x = - 0.5
                let y = bar.entry - h * 0.5 - 0.5
                let a = 7
                ctx.fillRect(x - 0.5, y, w + 1, h)
                ctx.fillStyle = comp.$props.colors.textHL
                ctx.textAlign = 'left'
                ctx.fillText(lbl, a, y + 15)

                lbl = bar.entryTarget ? bar.entryTarget.toFixed(layout.prec) : 0
                ctx.fillStyle = bar.targetColor

                x = - 0.5
                y = bar.target - h * 0.5 - 0.5
                a = 7
                ctx.fillRect(x - 0.5, y, w + 1, h)
                ctx.fillStyle = comp.$props.colors.textHL
                ctx.textAlign = 'left'
                ctx.fillText(lbl, a, y + 15)

                lbl = bar.entryStoploss ? bar.entryStoploss.toFixed(layout.prec) : 0
                ctx.fillStyle = bar.stoplossColor

                x = - 0.5
                y = bar.stoploss - h * 0.5 - 0.5
                a = 7
                ctx.fillRect(x - 0.5, y, w + 1, h)
                ctx.fillStyle = comp.$props.colors.textHL
                ctx.textAlign = 'left'
                ctx.fillText(lbl, a, y + 15)


                lbl = bar.pendingTarget ? bar.pendingTarget.toFixed(layout.prec) : 0
                ctx.fillStyle = bar.pendingTargetColor

                x = - 0.5
                y = bar.pending - h * 0.5 - 0.5
                a = 7
                ctx.fillRect(x - 0.5, y, w + 1, h)
                ctx.fillStyle = comp.$props.colors.textHL
                ctx.textAlign = 'left'
                ctx.fillText(lbl, a, y + 15)

            }
        })
        this.shader = true
    }

    // Regular draw call for overaly
    draw(ctx, plot) {
        if (!this.comp.$props.meta.last) return
        if (!this.shader) this.init_shader(plot)

        let layout = this.comp.$props.layout
        let last = (plot && plot.length) ? plot[plot.length - 1] : null
        if (!last || !last.entryDirection) return

        let dir = last.entryDirection === "BUY"
        let color = dir ? this.green() : this.red()
        let x = layout.full_candles[layout.full_candles.length - 1].x
        let y = layout.$2screen(last.entryPoint) + (dir ? 1 : 0)

        ctx.strokeStyle = color
        ctx.setLineDash([1, 1])
        ctx.beginPath()
        ctx.moveTo(x, y)
        ctx.lineTo(layout.width, y)
        ctx.stroke()
        ctx.setLineDash([])

        color = this.green()
        y = layout.$2screen(last.entryTarget) + (dir ? 1 : 0)

        ctx.strokeStyle = color
        ctx.setLineDash([1, 1])
        ctx.beginPath()
        ctx.moveTo(x, y)
        ctx.lineTo(layout.width, y)
        ctx.stroke()
        ctx.setLineDash([])

        color = this.red()
        y = layout.$2screen(last.entryStoploss) + (dir ? 1 : 0)

        ctx.strokeStyle = color
        ctx.setLineDash([1, 1])
        ctx.beginPath()
        ctx.moveTo(x, y)
        ctx.lineTo(layout.width, y)
        ctx.stroke()
        ctx.setLineDash([])


        color = this.black()
        y = layout.$2screen(last.pendingTarget) + (dir ? 1 : 0)

        ctx.strokeStyle = color
        ctx.setLineDash([1, 1])
        ctx.beginPath()
        ctx.moveTo(x, y)
        ctx.lineTo(layout.width, y)
        ctx.stroke()
        ctx.setLineDash([])
    }

    last_bar(plot) {

        if (!this.comp.$props.layout.full_candles.length) return undefined
        let layout = this.comp.$props.layout
        let last = plot[plot.length - 1]
        let x = layout.$2screen(layout.full_candles[layout.full_candles.length - 1].x)
        let entry = layout.$2screen(last.entryPoint)
        let target = layout.$2screen(last.entryTarget)
        let stoploss = layout.$2screen(last.entryStoploss)
        let pending = layout.$2screen(last.pendingTarget)
        return {
            x: x,
            entry: entry,
            target: target,
            stoploss: stoploss,
            pending: pending,
            entryPoint: last.entryPoint,
            entryStoploss: last.entryStoploss,
            entryTarget: last.entryTarget,
            pendingTarget: last.pendingTarget,
            entryColor: this.green(),
            stoplossColor: this.red(),
            targetColor: this.green(),
            pendingTargetColor: this.black()
        }
    }

    last_price() {
        return this.comp.$props.meta.last ?
            this.comp.$props.meta.last[4] : undefined
    }

    green() {
        return this.comp.upBarColor
    }

    red() {
        return this.comp.downBarColor
    }

    black() {
        return this.comp.pendingTargetColor
    }

}
